 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TOC from '@/components/toc'
 import XHTML01_COVER from '@/components/xhtml/01_Cover'
 import XHTML02_TITLEPAGE from '@/components/xhtml/02_Titlepage'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_ACKNOWLEDGEMENTS from '@/components/xhtml/06_Acknowledgements'
 import XHTML07_GLOSSARY from '@/components/xhtml/07_Glossary'
 import XHTML08_PREFACE from '@/components/xhtml/08_Preface'
 import XHTML09_INTRODUCTION from '@/components/xhtml/09_Introduction'
 import XHTML10_CHAPTER01 from '@/components/xhtml/10_Chapter01'
 import XHTML11_CHAPTER02 from '@/components/xhtml/11_Chapter02'
 import XHTML12_CHAPTER03 from '@/components/xhtml/12_Chapter03'
 import XHTML13_CHAPTER04 from '@/components/xhtml/13_Chapter04'
 import XHTML14_CHAPTER05 from '@/components/xhtml/14_Chapter05'
 import XHTML15_CHAPTER06 from '@/components/xhtml/15_Chapter06'
 import XHTML16_CHAPTER07 from '@/components/xhtml/16_Chapter07'
 import XHTML17_CHAPTER08 from '@/components/xhtml/17_Chapter08'
 import XHTML18_CHAPTER09 from '@/components/xhtml/18_Chapter09'
 import XHTML19_CHAPTER10 from '@/components/xhtml/19_Chapter10'
 import XHTML20_CHAPTER11 from '@/components/xhtml/20_Chapter11'
 import XHTML21_CHAPTER12 from '@/components/xhtml/21_Chapter12'
 import XHTML22_CHAPTER13 from '@/components/xhtml/22_Chapter13'
 import XHTML23_CHAPTER14 from '@/components/xhtml/23_Chapter14'
 import XHTML24_CHAPTER15 from '@/components/xhtml/24_Chapter15'
 import XHTML25_CHAPTER16 from '@/components/xhtml/25_Chapter16'
 import XHTML26_CHAPTER17 from '@/components/xhtml/26_Chapter17'
 import XHTML27_CHAPTER18 from '@/components/xhtml/27_Chapter18'
 import XHTML28_CHAPTER19 from '@/components/xhtml/28_Chapter19'
 import XHTML29_PLATES from '@/components/xhtml/29_Plates'
 import XHTML30_APPENDIX_I from '@/components/xhtml/30_Appendix_I'
 import XHTML31_APPENDIX_II from '@/components/xhtml/31_Appendix_II'
 import XHTML32_APPENDIX_III from '@/components/xhtml/32_Appendix_III'
 import XHTML33_APPENDIX_IV from '@/components/xhtml/33_Appendix_IV'
 import XHTML34_APPENDIX_V from '@/components/xhtml/34_Appendix_V'
 import XHTML35_APPENDIX_VI from '@/components/xhtml/35_Appendix_VI'
 import XHTML36_APPENDIX_VII from '@/components/xhtml/36_Appendix_VII'
 import XHTML37_APPENDIX_VIII from '@/components/xhtml/37_Appendix_VIII'
 import XHTML38_APPENDIX_IX from '@/components/xhtml/38_Appendix_IX'
 import XHTML39_APPENDIX_X from '@/components/xhtml/39_Appendix_X'
 import XHTML40_APPENDIX_XI from '@/components/xhtml/40_Appendix_XI'
 import XHTML41_APPENDIX_XII from '@/components/xhtml/41_Appendix_XII'
 import XHTML42_APPENDIX_XIII from '@/components/xhtml/42_Appendix_XIII'
 import XHTML43_APPENDIX_XIV from '@/components/xhtml/43_Appendix_XIV'
 import XHTML43_PLANS_POW from '@/components/xhtml/43_Plans_PoW'
 import XHTML44_NOTES_TO_CHAPTERS from '@/components/xhtml/44_Notes_to_Chapters'
 import XHTML45_BIBLIOGRAPHY from '@/components/xhtml/45_Bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/xhtml/01_Cover",
 			"name" : "xhtml/01_Cover",
 			"component" : XHTML01_COVER
 		},
 		{
 			"path" : "/xhtml/02_Titlepage",
 			"name" : "xhtml/02_Titlepage",
 			"component" : XHTML02_TITLEPAGE
 		},
 		{
 			"path" : "/xhtml/03_Copyright",
 			"name" : "xhtml/03_Copyright",
 			"component" : XHTML03_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/04_Dedication",
 			"name" : "xhtml/04_Dedication",
 			"component" : XHTML04_DEDICATION
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_Acknowledgements",
 			"name" : "xhtml/06_Acknowledgements",
 			"component" : XHTML06_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/07_Glossary",
 			"name" : "xhtml/07_Glossary",
 			"component" : XHTML07_GLOSSARY
 		},
 		{
 			"path" : "/xhtml/08_Preface",
 			"name" : "xhtml/08_Preface",
 			"component" : XHTML08_PREFACE
 		},
 		{
 			"path" : "/xhtml/09_Introduction",
 			"name" : "xhtml/09_Introduction",
 			"component" : XHTML09_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/10_Chapter01",
 			"name" : "xhtml/10_Chapter01",
 			"component" : XHTML10_CHAPTER01
 		},
 		{
 			"path" : "/xhtml/11_Chapter02",
 			"name" : "xhtml/11_Chapter02",
 			"component" : XHTML11_CHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js